import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private _snackBar = inject(MatSnackBar);

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        const message = error?.error?.error?.message ?? 'Something went wrong. Please try again later or contact support';
        this._snackBar.open(message, undefined, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });

        return throwError(() => error);
      }),
    );
  }
}
